<!-- Init Form for debugging (only shows in lower environments) -->
<form
  *ngIf="enablePromptEditingForSmartFix && showDevMode"
  class="initForm"
  [formGroup]="initForm!"
  (submit)="initiateBedrockChat()"
  cdkDrag
>
  <button
    style="position: fixed; bottom: 24px; right: 24px; z-index: 9999"
    (click)="showDevMode = !showDevMode"
  >
    toggle dev mode
  </button>
  <textarea
    name="prompt"
    placeholder="Custom initial prompt"
    class="input-wrapper pre-wrap-text"
    formControlName="prompt"
  ></textarea>
  <smart-fix-bedrock-chat-toggle
    (modeSelected)="onModeSelected($event)"
  ></smart-fix-bedrock-chat-toggle>

  <!-- Mode Selection Toggle -->
  <div class="mode-selection">
    <h4>Select Chat Mode:</h4>
    <div class="mode-toggles">
      <label class="mode-toggle">
        <input
          type="radio"
          name="chatMode"
          value="rag"
          [checked]="selectedMode === 'rag'"
          (change)="onModeSelected('rag')"
        />
        <span>RAG Mode (Retrieval-Augmented Generation)</span>
      </label>
      <label class="mode-toggle">
        <input
          type="radio"
          name="chatMode"
          value="agent-llm"
          [checked]="selectedMode === 'agent-llm'"
          (change)="onModeSelected('agent-llm')"
        />
        <span>Agentic LLM (Context Gathering)</span>
      </label>
      <label class="mode-toggle">
        <input
          type="radio"
          name="chatMode"
          value="docs"
          [checked]="selectedMode === 'docs'"
          (change)="onModeSelected('docs')"
        />
        <span>Chat with Docs</span>
      </label>
    </div>
    <p class="mode-description">
      <em>
        <strong>Selected:</strong> {{ selectedMode || 'None' }} -
        <span *ngIf="selectedMode === 'rag'"
          >Uses knowledge base for precise solutions</span
        >
        <span *ngIf="selectedMode === 'agent-llm'"
          >Gathers context through questions first</span
        >
        <span *ngIf="selectedMode === 'docs'"
          >Searches documentation for answers</span
        >
      </em>
    </p>
  </div>

  <div class="input-wrapper pre-wrap-text">
    <select
      name="modelArn"
      placeholder="Select model"
      formControlName="modelArn"
    >
      <option
        *ngFor="let option of modelOptions"
        [value]="option.value"
        selected
      >
        {{ option.label }}
      </option>
    </select>
  </div>

  <dgx-form-field formControlName="initialMessage">
    <dgx-form-text-input
      name="initialMessage"
      placeholder="Initial message"
    ></dgx-form-text-input>
  </dgx-form-field>

  <dgx-components-icon
    *ngIf="initForm?.valid"
    class="send-prompt-icon"
    name="send"
    [ariaDisabled]="!initForm?.valid"
    size="lg"
    type="submit"
    (click)="initiateBedrockChat()"
    (keydown.enter)="initiateBedrockChat()"
  ></dgx-components-icon>
  <br />
  <em>
    Note: Start by tweaking the input of the initial message above. Then click
    the button above to start. Then continue the discussion in the chat
    container.
  </em>

  <br />
  <br />
  <div>
    <p>This is only for lower envs and debugging reasons.</p>
    <br />
    <em>
      In production, the initial message will be sent automatically. The reason
      we have it like this in development environments is for the product team
      to test it and come up with the best approach for the initial message
      and/or tweaking of the prompt.
    </em>
  </div>
</form>

<!-- Main Chat Container -->
<div class="chat-container">
  <span *ngIf="showTopGradient" class="chat-scroll-gradient"> </span>
  <div
    class="scrollable-chat"
    #scrollContainer
    [ngClass]="{
      'chat-separator': enableVoiceCapture && !isLoading,
    }"
  >
    <h2 class="heading-1" [innerHTML]="title"></h2>

    <div class="chat-messages">
      <div *ngFor="let item of history; let i = index; let isLast = last">
        <section [class]="item.role">
          <div *ngIf="item.role === 'agent'">
            <div *ngIf="!isLoading && isLast">
              <smart-fix-model-response-character-typing
                [content]="item.content.message"
              ></smart-fix-model-response-character-typing>
            </div>
            <!--welcome message-->
            <smart-fix-lex-plain-text
              *ngIf="!isLast"
              [plainTextDescription]="item.content.message"
            />
          </div>

          <div *ngIf="item.role === 'user'">
            <div *ngIf="item.content.message" class="user">
              <p class="message body history-item" [dgxQmSanitise]="'encrypt'">
                {{ item.content.message }}
              </p>
            </div>

            <div
              class="user-attached-image"
              *ngIf="item.content.images && item.content.images.length > 0"
            >
              <div
                *ngFor="let image of item.content.images"
                class="user-image-item"
              >
                <img
                  [src]="'data:' + image.mimeType + ';base64,' + image.data"
                  [alt]="image.filename"
                />
              </div>
            </div>
          </div>
        </section>
      </div>
      <!-- Image prompt buttons -->
      <div
        *ngIf="showImagePrompt && !enableImageAttachment"
        class="image-prompt-container"
      >
        <div class="image-prompt-buttons">
          <dgx-components-button
            variant="secondary"
            class="image-prompt-btn attach"
            (click)="promptToAttachImage()"
          >
            Yes, attach an image
          </dgx-components-button>
          <dgx-components-button
            variant="secondary"
            class="image-prompt-btn skip"
            (click)="skipImageAttachment()"
          >
            No, continue without an image
          </dgx-components-button>
        </div>
      </div>

      <div
        *ngIf="
          showImagePrompt &&
          enableImageAttachment &&
          selectedImages.length === 0
        "
      >
        <smart-fix-image-attach-component
          (imageAttached)="onImageAttached($event)"
          (imageAttachedSuccess)="onImageAttachedSuccess($event)"
        ></smart-fix-image-attach-component>
      </div>

      <!-- Loading animation -->
      <div *ngIf="isLoading" class="text--left loading-chat-container">
        <smart-fix-app-loading-dots></smart-fix-app-loading-dots>
      </div>

      <!-- Feedback section -->
      <div class="history-item">
        <smart-fix-bedrock-feedback
          [claim]="claim"
          *ngIf="isFeedback"
          [sessionId]="sessionId"
          (requestFeedback)="onRequestFeedback()"
          (closeChat)="closeChat()"
          [feedback]="feedback"
        ></smart-fix-bedrock-feedback>
      </div>
    </div>
  </div>

  <!-- Chat Input Section -->
  <div class="chat-input" *ngIf="chatForm && !isFeedback">
    <!-- Voice recording indicator -->
    <div class="action-icons">
      <div
        class="voice-recording"
        [class.active]="isListening"
        *ngIf="isListening"
      >
        <span class="recording-indicator"></span>
        <p class="body">Writing your speech</p>
      </div>

      <div
        class="clear-button"
        *ngIf="
          chatForm.get('message')?.value?.length && this.enableVoiceCapture
        "
        (click)="onClearButton()"
        (keydown.enter)="onClearButton()"
        tabindex="0"
      >
        <p class="body">Clear</p>
        <i class="fa-light fa-trash-can-xmark"></i>
      </div>
    </div>

    <form
      [formGroup]="chatForm"
      (submit)="onSubmit($event)"
      (keydown.enter)="onSubmit($event)"
    >
      <div
        class="input-wrapper"
        [class.has-image]="selectedImages.length > 0"
        tabindex="0"
      >
        <!-- Image attachment preview -->
        <div *ngIf="selectedImages.length > 0" class="attached-image-container">
          <img
            [src]="selectedImages[0].preview"
            class="attached-image-preview"
          />
          <div class="image-actions">
            <i
              class="fa-light fa-image fa-lg"
              (click)="promptToAttachImage()"
            ></i>
            <i
              class="fa-light fa-xmark fa-lg"
              (click)="removeImage(0); showImagePrompt = true"
            ></i>
          </div>
        </div>

        <!-- Text input -->
        <textarea
          #textArea
          name="message"
          [placeholder]="
            chatForm.get('message')?.value
              ? chatForm.get('message')?.value
              : 'Write here'
          "
          formControlName="message"
          (focus)="onFocusInput()"
          (blur)="onBlurInput()"
          (input)="autoResize()"
          (keydown.enter)="onEnter($event)"
          [rows]="1"
          autofocus
          dgxQmSanitise="encrypt"
        ></textarea>

        <div class="action-icon-container">
          <!-- Voice capture icon -->
          <i
            *ngIf="enableVoiceCapture && !showImagePrompt"
            class="fa-light fa-lg"
            [ngClass]="
              isListening ? 'fa-pause recording-voice-icon' : 'fa-microphone'
            "
            (click)="voiceCaptureToggle()"
            tabindex="0"
            role="button"
          ></i>

          <!-- Send icon -->
          <i
            class="fa-light fa-arrow-up fa-lg send-icon"
            tabindex="0"
            role="button"
            [attr.aria-disabled]="
              isLoading ||
              !chatForm.valid ||
              (enableVoiceCapture &&
                chatForm.get('message')?.value?.length === 0)
            "
            [class.disabled]="
              isLoading ||
              (enableVoiceCapture &&
                chatForm.get('message')?.value?.length === 0)
            "
            (click)="!isLoading && onSubmit($event)"
            (keydown.enter)="!isLoading && onSubmit($event)"
          ></i>
        </div>
      </div>
    </form>
  </div>

  <!-- Feedback form -->
  <smart-fix-bedrock-feedback-form
    *ngIf="!feedback && feedbackRequested"
    (sendFeedback)="onSendFeedback($event)"
  ></smart-fix-bedrock-feedback-form>
</div>
